/* eslint-disable @eslint-react/naming-convention/filename -- don't need to follow this convention for this file */
import '@/setup'

import {reactErrorHandler} from '@sentry/react'
import {RouterProvider} from '@tanstack/react-router'
import {InferSeoMetaPlugin} from '@unhead/addons'
import {createHead, UnheadProvider} from '@unhead/react/client'
import {AliasSortingPlugin, CanonicalPlugin} from '@unhead/react/plugins'
import {createStore} from 'jotai'
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'

import {createQueryClient} from './queries/queries'
import {createRouter} from './router'

const head = createHead({
  plugins: [
    AliasSortingPlugin,
    CanonicalPlugin({
      canonicalHost: 'https://mysite.com',
    }),
    InferSeoMetaPlugin(),
  ],
})

function App() {
  // Ensures each request has its own cache in SSR
  // eslint-disable-next-line @eslint-react/naming-convention/use-state -- not needed
  const [queryClient] = useState(() => createQueryClient())

  // eslint-disable-next-line @eslint-react/naming-convention/use-state -- not needed
  const [store] = useState(() => createStore())

  // eslint-disable-next-line @eslint-react/naming-convention/use-state -- not needed
  const [router] = useState(() => createRouter({queryClient, store}))

  return (
    <RouterProvider
      router={router}
      context={{
        store,
        queryClient,
      }}
    />
  )
}

function render() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- its guaranteed to be there
  createRoot(document.getElementById('root')!, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack)
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: reactErrorHandler(),
  }).render(
    <StrictMode>
      <UnheadProvider head={head}>
        <App />
      </UnheadProvider>
    </StrictMode>,
  )
}

render()
/* eslint-enable @eslint-react/naming-convention/filename */
